<h4 mat-dialog-title>Dev Mode Access</h4>
<div mat-dialog-content>
	<p>Enter the password to access dev mode tools:</p>
	<mat-form-field appearance="outline" class="full-width">
		<mat-label>Password</mat-label>
		<input matInput type="password" [formControl]="passwordControl" (keyup.enter)="onSubmit()" autocomplete="off">
		<mat-error *ngIf="passwordControl.hasError('required')">
			Password is required
		</mat-error>
	</mat-form-field>
	<div class="error-message" *ngIf="errorMessage">
		{{ errorMessage }}
	</div>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onCancel()">Cancel</button>
	<button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="passwordControl.invalid">
		Submit
	</button>
</div>

